/**
 * Persistierte Spieleinstellungen (localStorage).
 * UI wird im PlayerBadge-Dropdown gerendert.
 */
const STORAGE_KEY = 'isr:settings';
const DEFAULTS = { panSpeed: 1.5 };

export interface GameSettings {
  panSpeed: number;
}

let _settings: GameSettings | null = null;

export function getSettings(): GameSettings {
  if (_settings) return _settings;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) { _settings = { ...DEFAULTS, ...JSON.parse(raw) }; return _settings!; }
  } catch { /* ignore */ }
  _settings = { ...DEFAULTS };
  return _settings;
}

export function saveSettings(): void {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(_settings)); } catch { /* ignore */ }
}
